module.exports = __webpack_public_path__ + "img/eswatini.4ea0b07e.svg";